import Image from 'next/image'
import { ClearButton } from '../ui/clear-button'

export function TitanHeader() {
  return (
    <div className="px-4 py-4 lg:px-8  lg:py-7 bg-[#c00000] sticky items-center top-0 text-white z-10 flex gap-8 justify-between lg:justify-start">
      <Image
        alt="titan-machinery-logo"
        width={124}
        height={32}
        className="h-8"
        src={'/images/titan-machinery-logo.webp'}
      ></Image>
      <ClearButton />
    </div>
  )
}
